import axios from 'axios';
import router from './router';

const axiosRequest = axios.create({
  timeout: 10000
});

axiosRequest.interceptors.response.use(
  response => response,
  (error) => {
    if (error.message.includes('Network Error') || error.code === 'ECONNABORTED') {
      router.push({name: 'NoInternetConnection'});
    }
    throw error;
  }
);

export default axiosRequest;



// WEBPACK FOOTER //
// ./src/axios.js